<script lang="ts">
    import { onMount } from "svelte";
    import { appstates } from "../../stores/app-state";
    import { RequirementStore } from "../../stores/requirement-store";
    import Step from "../common/step.component.svelte";
    import * as actorsJSON from '../../json/actors.json';  
    import Proposal from "../common/proposal.component.svelte";
    import OutlineButton from "../common/outline-button.component.svelte";
    import InputBox from "../ui/InputBox.svelte";
    import AddIcon from "../ui/icons/icon-add.svelte";
    import ListWidthDelete from "../ui/list-with-delete.svelte";


    // Export
    export let title: string = "";

    // Vars
    // -- Actors
    let actors: string[] = [];
    // -- Current actor
    let currentActor: string = "";

    // Reactive
    // --- Add button enabled
    $: btnAddEnabled = currentActor.trim().length >= 5;
    // -- Next possible ?
    $: nextEnable = actors.length >= 2;

    // Function
    // -- onMount
    onMount(() => {
        actors = RequirementStore.getActors();
    });
    // -- Handle a new Stake
    const handleNew = () => {
        if (btnAddEnabled) {
            // Add
            addNew(currentActor);
            // Clear the text
            currentActor = "";
        }
    };
    const addNew = (p:string) => {
        if(actors.indexOf(p) === -1) {
            // Record in the list
            actors = [...actors, p];
        }
    }
    // -- Handle ask for delete a stake
    const handleDelete = (actor: string) => {
        // Filter
        actors = actors.filter((s) => s !== actor);
    };

    const handleNext = () => {
        // Check
        if (nextEnable) {
            RequirementStore.updateActors(actors);
            appstates.next();
        }
    };
</script>

<Step title={ title } {nextEnable} on:navigation-next={handleNext} imageIndex= { $appstates } >
    <span slot="presentation">
        Un projet n'a d'intérêt qui si des personnes l'utilisent. Ici, l'idée
        n'est pas de lister les personnes physiques mais les rôles qu'elles
        peuvent jouer.
    </span>

    <span slot="content" >
        <!-- div.content -->
        <div class="content" >
            <div  class="content-part">
                <InputBox>
                    <input 
                        type="text" 
                        bind:value={currentActor} 
                        placeholder="Qui va utiliser votre projet ?" 
                        on:keydown={(e) => { 
                            if(btnAddEnabled && e.key == "Enter") {
                                handleNew();
                            }
                        }}
                        /> 
                    <OutlineButton on:click={handleNew} disabled={! btnAddEnabled } > <AddIcon /> </OutlineButton>
                </InputBox>
                <small class="help"> Au moins deux acteurs. Chaque acteur doit faire 5 caractères </small>
                <ListWidthDelete
                    list={actors}
                    on:delete={(e) => { handleDelete(e.detail) }}
                        />
            </div>
            <hr/>
            <div class="content-part">
                <h3> Propositions </h3>
                <Proposal propositions={actorsJSON.list} on:proposal-selected={(e) => addNew(e.detail) } />
            </div>
        </div> <!-- /div.content -->
    </span>
</Step>
